import { api } from "../api/client";

export type Theme = "dark" | "light" | "red";
export const THEMES: Theme[] = ["light", "red", "dark"];
const KEY = "gdt.theme";

export const isTheme = (v: unknown): v is Theme => v === "dark" || v === "light" || v === "red";

export function currentTheme(): Theme {
  const t = document.documentElement.dataset.theme;
  return isTheme(t) ? t : "dark";
}

/** Applies instantly; animates colors only during the switch (skipped under reduced motion). */
export function applyTheme(theme: Theme, animate = true): void {
  const root = document.documentElement;
  try { localStorage.setItem(KEY, theme); } catch { /* storage disabled */ }
  if (root.dataset.theme === theme) return;
  const motion = animate && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (motion) root.classList.add("theme-transition");
  root.dataset.theme = theme;
  window.dispatchEvent(new CustomEvent("gdt-theme", { detail: theme }));
  if (motion) window.setTimeout(() => root.classList.remove("theme-transition"), 300);
}

export const saveTheme = (ui_theme: Theme) => api.put<{ ui_theme: Theme }>("/me/preferences", { ui_theme });
